import { Builder } from '@builder.io/sdk';
import MainHeader from './MainHeader';

Builder.registerComponent(MainHeader, {
	name: 'MainHeader',
	// Expose props for editing in Builder
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Header Text (optional)',
			type: 'string',
			defaultValue: 'Total Injury Help',
		},
		{
			name: 'links',
			type: 'list',
			subFields: [
				{ name: 'label', type: 'string', defaultValue: 'Home' },
				{ name: 'url', type: 'url', defaultValue: '/' },
			],
			defaultValue: [
				{ label: 'Home', url: '/' },
				{ label: 'Current Cases', url: '/cases' },
				{ label: 'Our Process', url: '/process' },
				{ label: 'See If You Qualify', url: '/qualify' },
			],
		},
		{
			name: 'usePageColors',
			friendlyName: 'Use Page Colors',
			type: 'boolean',
			defaultValue: true,
			helperText:
				'If true, will use colors set on page for styling; if false, use the controls below',
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: '#313E64',
			helperText: 'Be sure to select a color light enough for the text to have contrast',
			showIf: function (options) {
				return options.get('usePageColors') === false;
			},
		},
		{
			name: 'textColor',
			friendlyName: 'Text Color',
			type: 'color',
			defaultValue: '#FFF',
			helperText: 'Be sure to select a color light enough for the text to have contrast',
			showIf: function (options) {
				return options.get('usePageColors') === false;
			},
		},
		{
			name: 'mobileLogo',
			friendlyName: 'Mobile Logo',
			type: 'boolean',
			defaultValue: true,
			helperText: 'Should the logo be shown at mobile sizes?',
		},
	],
});
